<template>
  <div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Status</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <v-select
          :searchable="true"
          :options="optionStatus"
          :clearable="true"
          v-model="selectedStatus"
        >
        </v-select>
      </div>
    </div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="country">Country</vs-th>
        <vs-th sort-key="province">Province</vs-th>
        <vs-th sort-key="city">City</vs-th>
        <vs-th sort-key="district">District</vs-th>
        <vs-th sort-key="sub_district">Sub District</vs-th>
        <vs-th sort-key="address">Address</vs-th>
        <vs-th sort-key="postal_code">Postal Code</vs-th>
        <vs-th sort-key="latitude">Latitude</vs-th>
        <vs-th sort-key="longitude">Longitude</vs-th>
        <vs-th sort-key="phone">Phone</vs-th>
        <vs-th sort-key="fax">Fax</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="contact_name">Contact Name</vs-th>
        <vs-th sort-key="contact_mobile">Contact Mobile</vs-th>
        <vs-th sort-key="pkp">PKP</vs-th>
        <vs-th sort-key="sppkp">SPPKP</vs-th>
        <vs-th sort-key="npwp">NPWP</vs-th>
        <vs-th sort-key="npwp_16_digit">NPWP 16 Digit</vs-th>
        <vs-th sort-key="tdp">TDP</vs-th>
        <vs-th sort-key="siup">SIUP</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="status">Information</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.data.code">
            {{ tr.data.code }}
          </vs-td>
          <vs-td :data="tr.data.name">
            {{ tr.data.name }}
          </vs-td>
          <vs-td :data="tr.data.country">
            {{ tr.data.country }}
          </vs-td>
          <vs-td :data="tr.data.province">
            {{ tr.data.province }}
          </vs-td>
          <vs-td :data="tr.data.city">
            {{ tr.data.city }}
          </vs-td>
          <vs-td :data="tr.data.district">
            {{ tr.data.district }}
          </vs-td>
          <vs-td :data="tr.data.sub_district">
            {{ tr.data.sub_district }}
          </vs-td>
          <vs-td :data="tr.data.address">
            {{ tr.data.address }}
          </vs-td>
          <vs-td :data="tr.data.postal_code">
            {{ tr.data.postal_code }}
          </vs-td>
          <vs-td :data="tr.data.latitude">
            {{ tr.data.latitude }}
          </vs-td>
          <vs-td :data="tr.data.longitude">
            {{ tr.data.longitude }}
          </vs-td>
          <vs-td :data="tr.data.phone">
            {{ tr.data.phone }}
          </vs-td>
          <vs-td :data="tr.data.fax">
            {{ tr.data.fax }}
          </vs-td>
          <vs-td :data="tr.data.email">
            {{ tr.data.email }}
          </vs-td>
          <vs-td :data="tr.data.contact_name">
            {{ tr.data.contact_name }}
          </vs-td>
          <vs-td :data="tr.data.contact_mobile">
            {{ tr.data.contact_mobile }}
          </vs-td>
          <vs-td :data="tr.data.pkp">
            {{ tr.data.pkp }}
          </vs-td>
          <vs-td :data="tr.data.sppkp">
            {{ tr.data.sppkp }}
          </vs-td>
          <vs-td :data="tr.data.npwp">
            {{ tr.data.npwp }}
          </vs-td>
          <vs-td :data="tr.data.npwp_16_digit">
            {{ tr.data.npwp_16_digit }}
          </vs-td>
          <vs-td :data="tr.data.tdp">
            {{ tr.data.tdp }}
          </vs-td>
          <vs-td :data="tr.data.siup">
            {{ tr.data.siup }}
          </vs-td>
          <vs-td :data="tr.status">
            {{ tr.status }}
          </vs-td>
          <vs-td :data="tr.remark">
            {{ tr.remark }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";

export default {
  components: { vSelect },
  props: {
    baseUrl: {
      type: String,
    },
    logImportID: {
      type: Number,
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
  },
  data() {
    return {
      table: this.tableDefaultState(),
      optionStatus: [],
      selectedStatus: "",
      selectedSearchKeys: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },

    getData() {
      this.$vs.loading();
      const params = {
        length: this.table.length,
        page: this.table.page,
        search: this.table.search,
        order: this.table.order,
        sort: this.table.sort,
        log_import_id: this.logImportID,
        status: this.selectedStatus,
        search_keys: this.selectedSearchKeys.length > 0 ? this.selectedSearchKeys : ['']
      };

      this.$http
        .get("/api/wms/v1/master-import/log-import-line-v3", {params})
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;

            if (this.table.data && this.selectedSearchKeys.length === 0 && this.table.data.length > 0) {
              this.selectedSearchKeys = Object.keys(this.table.data[0].data)
                .filter(key => key !== "status" && key !== "remark");
            }

            if (this.table.data) {
              if (this.selectedStatus === "") {
                this.optionStatus = []
              }

              this.table.data.forEach(e => {
                if (!this.optionStatus.includes(e.status) && this.selectedStatus === "") {
                  this.optionStatus.push(e.status)
                }
              });
            }

            this.setStartEnd();
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.error(error);
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
  },
  watch: {
    logImportID() {
      console.log('logImportID changed');
      this.getData();
    },
    selectedStatus() {
      console.log('selectedStatus changed');
      this.getData();
    },
    selectedSearchKeys() {
      console.log('selectedSearchKeys changed');
      this.getData();
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
